import { Validator, AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';

export class ExternalDocumentValidator implements Validator {

    public static ALLOWED_CHARACTERS = /[^A-Za-z0-9]+/g;

    public static validate(c: AbstractControl): ValidationErrors | null {

        if (!c.value) {
            return undefined;
        }

        if (c.value.length < 5 || c.value.length > 50) {
            return {invalid: true};
        }

        if (!c.value.match(ExternalDocumentValidator.ALLOWED_CHARACTERS)) {
            return undefined;
        } else {
            return {invalid: true};
        }
    }

    public validate(c: AbstractControl): ValidationErrors | null {
        return ExternalDocumentValidator.validate(c);
    }
}
